import { render, staticRenderFns } from "./referralDtail.vue?vue&type=template&id=baa439a0&scoped=true"
import script from "./referralDtail.vue?vue&type=script&lang=js"
export * from "./referralDtail.vue?vue&type=script&lang=js"
import style0 from "./referralDtail.vue?vue&type=style&index=0&id=baa439a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa439a0",
  null
  
)

export default component.exports